export function replaceSpaces(str: string, newSeparator = '-'): string {
    return str.replace(/\s/g, newSeparator).toLowerCase()
}
